import { CgWebsite } from "react-icons/cg";
import { FaReact } from "react-icons/fa";
// import People2 from "../imgs/people2.png"

export const projectExperience = [
  {
    name: "React Applications",
    projects: "20+",
    icon: FaReact,
    bg: "#286F6C",
  },
  {
    name: "Test Websites in React.Js",
    projects: "30+",
    message: "( Click here to visit my Github repositories)",
    icon: CgWebsite,
    bg: "#EEC048",
  },
];

export const workExp = [
  {
    company: "Upwork",
    place: "Remote, Pakistan",
    tenure: "JAN 2025 - Present",
    totalTime: "(6 Months)",
    role: "Full Stack Developer",
    detail:
      "Developed and deployed responsive full-stack web applications using React.js, Node.js, and TypeScript for global clients across e-commerce, education, and SaaS domains. Built dynamic user interfaces with React.js, integrating Redux and Context API for efficient state management. Designed and consumed RESTful APIs and managed backend services using Node.js, Express.js. Integrated third-party services like Stripe, Firebase, and SendGrid for payment, authentication, and notifications.",
  },
  {
    company: "Glowingsoft Technologies",
    place: "Lahore, Punjab, Pakistan",
    tenure: "SEP 2023 - JAN 2025",
    totalTime: "(2 Months)",
    role: "Full Stack Developer",
    detail:
      " During my tenure, I actively contributed to projects leveraging these technologies, demonstrating my proficiency in building dynamic user interfaces with React, implementing server-side logic using Node.js and Express.js, and managing data storage with MongoDB and Firebase. My experience in the MERN stack has equipped me with a solid foundation in web development, allowing me to effectively collaborate on multifaceted projects and deliver high-quality solutions.",
  },
  {
    company: "Global Scope Developers",
    place: "Remote, Pakistan",
    tenure: "JUL 2022 - SEP 2023",
    totalTime: "(1 Year 2 Months)",
    role: "MERN Stack Developer",
    detail:
      "In my role as a Full Stack Developer, I Architecting and implementing dynamic web solutions, leveraging Full stack expertise to drive successful project outcomes. Meticulously designing MongoDB databases, Firebase for user authentication and crafting engaging React-based user interfaces, ensuring optimal user experiences.",
  },
  {
    company: "Orbix Technologies",
    place: "Lahore, Punjab, Pakistan",
    tenure: "JUL 2021 - DEC 2021",
    totalTime: "(6 month)",
    role: "Full Stack Developer",
    detail:
      "During my tenure as a Junior Frontend Developer (Intern) at Orbix Technologies, I had the opportunity to contribute actively to the development of web applications. This role allowed me to gain hands-on experience with modern frontend technologies, frameworks, and libraries, improving my skills in HTML, CSS, JavaScript, React, Redux, TailwindCSS & Bootstrap, etc. My time at Orbix Technologies significantly enhanced my understanding of front-end development practices and methodologies, providing a valuable foundation for my career growth in the field.",
  },
];

export const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  touchMove: true,
  useCSS: true,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
